export const Stat = {
  baseStyle: {
    label: {
      fontWeight: 'normal'
    }
  }
}
